import React from 'react';
import { connect } from 'react-redux';
import { withFormik, Field, Form, getIn } from 'formik';
import * as Yup from 'yup';
import { Button, Row, Col, Modal } from 'react-bootstrap';

import { FormikCheckBox, FormikInput, FormikSelect } from '../../components';

const PERMISSION_TYPE_OPTIONS = [
  { label: 'Permiso con Goce', value: 'with_pay' },
  { label: 'Permiso sin Goce', value: 'without_pay' }
];

const PermissionClassificationForm = props => {
  const { onHide, submitVariant, errors, touched, action, setFieldValue, isSubmitting } = props;
  const btnMessage = action === 'new' ? 'Crear' : 'Guardar';

  return (
    <Form>
      <Modal.Body>
        <Row>
          <Col md={12}>
            <Row>
              <Col md={12}>
                <Field name="permissionClassification[name]">
                  {({ field }) => (
                    <FormikInput
                      {...field}
                      abbr
                      label="Nombre"
                      error={getIn(errors, field.name)}
                      touched={getIn(touched, field.name)}
                    />
                  )}
                </Field>
              </Col>
              <Col md={12}>
                <Field name="permissionClassification[permissionType]">
                  {({ field }) => {
                    const permissionTypeValue = field.value;
                    const defaultValue =
                      permissionTypeValue && PERMISSION_TYPE_OPTIONS.find(opt => opt.value === permissionTypeValue);
                    return (
                      <FormikSelect
                        {...field}
                        abbr
                        label="Tipo de Permiso"
                        placeholder="Seleccionar tipo de permiso"
                        options={PERMISSION_TYPE_OPTIONS}
                        defaultValue={defaultValue?.value}
                        onChange={data => setFieldValue(field.name, data ? data.value : '')}
                        setFieldTouched={() => props.setFieldTouched(field.name)}
                        error={getIn(errors, field.name)}
                        touched={getIn(touched, field.name)}
                      />
                    );
                  }}
                </Field>
              </Col>
              <Col md={12}>
                <Field name="permissionClassification[active]">
                  {({ field }) => <FormikCheckBox {...field} field={field} label="Activo" />}
                </Field>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button type="submit" className="btn" disabled={isSubmitting} variant={submitVariant} onClick={onHide}>
          {btnMessage}
        </Button>
      </Modal.Footer>
    </Form>
  );
};

const setInitialValues = props => {
  const { id, name, permissionType, active } = props.permissionClassification;
  return {
    permissionClassification: {
      id,
      name: name || '',
      permissionType,
      active: active !== undefined ? active : true
    }
  };
};

const validationSchema = Yup.object().shape({
  permissionClassification: Yup.object().shape({
    name: Yup.string()
      .required('Debes ingresar un nombre')
      .max(50, 'Deben ser menos de 50 caracteres'),
    permissionType: Yup.string().required('Debes seleccionar un tipo de permiso'),
    active: Yup.boolean()
  })
});

const handleSubmit = (values, { props, setSubmitting }) => {
  const { formRequest } = props;
  formRequest(values, setSubmitting);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: props => props.action !== 'new'
})(connect()(PermissionClassificationForm));
